import { render, staticRenderFns } from "./ChatSimulator.vue?vue&type=template&id=080195e5&scoped=true&"
import script from "./ChatSimulator.vue?vue&type=script&lang=js&"
export * from "./ChatSimulator.vue?vue&type=script&lang=js&"
import style0 from "./ChatSimulator.vue?vue&type=style&index=0&id=080195e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080195e5",
  null
  
)

export default component.exports